/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VulnerabilityExplorerWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("VulnerabilityExplorerWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return VulnerabilityExplorerWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<VulnerabilityExplorerWidgetConfiguration>): VulnerabilityExplorerWidgetConfiguration {
        let obj = Object.assign(new VulnerabilityExplorerWidgetConfiguration(), model);
        VulnerabilityExplorerWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VulnerabilityExplorerWidgetConfiguration>): VulnerabilityExplorerWidgetConfiguration {
        if (!model) return null;
        return VulnerabilityExplorerWidgetConfiguration.newInstance(<VulnerabilityExplorerWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VulnerabilityExplorerWidgetConfiguration) {
        if (!obj) return;

        models.VulnerabilityExplorerWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VulnerabilityExplorerWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, VulnerabilityExplorerWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
